var React = require('react');

function UiBack (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Back"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M0,45A45,45,0,1,0,45,0,45.05,45.05,0,0,0,0,45Zm20-4.52L38.06,22.39a6.39,6.39,0,0,1,9,9l-7.17,7.18H65.51A6.4,6.4,0,0,1,71.91,45h0a6.41,6.41,0,0,1-6.4,6.4H39.93l7.17,7.17a6.39,6.39,0,0,1-9,9L20,49.52a6.38,6.38,0,0,1,0-9Z"})))]);
}

UiBack.defaultProps = {"role":"presentation","version":"1.1","viewBox":"0 0 90 90","x":"0px","y":"0px","style":{"enableBackground":"new 0 0 90 90"},"xmlSpace":"preserve"};

module.exports = UiBack;

UiBack.default = UiBack;
